import { Button, Header, Segment } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../../components/Flex/Flex";
import useArticleTypeTranslations from "../../../../articles/hooks/useArticleTypeTranslations";
import CoverImage from "../../../../ui/components/CoverImage/CoverImage";

export default function CreateProductionArticleListItem({ article, onClick }) {
	const articleTypeTranslations = useArticleTypeTranslations();

	return (
		<Segment style={{ width: 500, margin: "auto" }}>
			<Flex alignItems="center" justifyContent="flex-start">
				<div style={{ marginRight: "1em", height: 45, width: 45 }}>
					<CoverImage rounded data={article} size={45} style={{ margin: "0 auto" }} />
				</div>

				<div>
					<Header as="h5" style={{ margin: 0 }}>
						{article.name}
					</Header>

					<div style={{ opacity: 0.4, fontSize: "0.9em" }}>{`${articleTypeTranslations[article.type]} (${
						article.isbn
					})`}</div>
				</div>
			</Flex>

			<Button
				basic
				circular
				icon="minus"
				style={{
					height: 28,
					width: 28,
					padding: 0,
					position: "absolute",
					right: 15,
					top: 20,
				}}
				onClick={onClick}
			/>
		</Segment>
	);
}
